// extracted by mini-css-extract-plugin
export default {"dot":"LoadingDots_dot__l3Iwg","dots-loader":"LoadingDots_dots-loader__GVf-9"};